import Textfield from "../../../common/components/Textfiled.jsx"
import  Textarea from "../../../common/components/Textareafield.jsx"
import FileUploader from "../../../common/components/FileUploader.jsx"
import Button from "../../../common/components/Button.jsx"


function FormMonthlyReport({monthlyReport, onChange, onSubmit, errors}) {
    const handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onSubmit) {
      onSubmit();
    }
  }

    return (
    <form onSubmit={handleSubmit}>
        <FileUploader onFileChange={(file) => onChange({name: "file", value: file})} value={monthlyReport.file} error={errors?.file} />
        <Textfield label="Fecha" type="date" name="date" value={monthlyReport.date} onChange={onChange} error={errors?.date} />
        <Textarea label="Observaciones" placeholder="Escribe las observaciones aquí" name="observations" value={monthlyReport.observations || ""} onChange={onChange} />
      <Button type="submit">Guardar</Button>
    </form>
    )
  }

export default FormMonthlyReport;
